/**
 * API key encoding/decoding utility.
 * Obfuscates API keys so they don't appear as plain text in browser DevTools.
 * Encoding: reverse the string, then Base64-encode.
 * Decoding: Base64-decode, then reverse.
 */

const encodeApiKey = (plainKey) => {
  const reversed = plainKey.split('').reverse().join('')
  return btoa(reversed)
}

const decodeApiKey = (encodedKey) => {
  const decoded = atob(encodedKey)
  return decoded.split('').reverse().join('')
}

export { encodeApiKey, decodeApiKey }
